import { Component, Input, ViewChild } from '@angular/core';
import { Menu } from 'primeng/menu';
import { ButtonGroupOptions } from '../../models/button-group.models';
import { BaseButtonComponent } from '../base/base-button.component';

@Component({
  selector: 'shared-ui-buttons-dropdown-menu-button',
  templateUrl: './dropdown-menu-button.component.html',
  styleUrl: './dropdown-menu-button.component.css',
  standalone: false,
})
export class DropdownMenuButtonComponent extends BaseButtonComponent {
  @Input() buttonOptions: ButtonGroupOptions[] = [];
  @Input() styleClass = 'bg-transparent';
  @Input() customToggle = false;
  @Input() appendTo: string = 'body';

  @ViewChild('menu') menu!: Menu;

  toggleMenu(event: Event): void {
    this.menu.toggle(event);
  }
}
